import Image from 'next/image';
import React from 'react';
interface ProfileAvatarProps {
  imageUrl?: string;
  onUpload: () => void;
  name?: string;
}
const getRandomPastelColor = () => {
  const hue = Math.floor(Math.random() * 360);
  return `hsl(${hue}, 70%, 80%)`;
};
function ProfileAvatar({
  imageUrl,
  name
}: ProfileAvatarProps) {
  // Extract first letter of name and capitalize it
  const firstLetter = name ? name.charAt(0).toUpperCase() : '';

  // Generate background color if no image
  const backgroundColor = getRandomPastelColor();

  // Render logic
  const renderAvatar = () => {
    if (imageUrl) {
      return <Image src={imageUrl} alt="Profile" width={120} height={120} className="size-[120px] rounded-full object-cover" />;
    }

    // Fallback avatar with first letter
    return <div className="flex size-[120px] items-center justify-center rounded-full text-3xl font-bold" style={{
      backgroundColor,
      color: 'rgba(0,0,0,0.7)'
    }} data-sentry-component="renderAvatar" data-sentry-source-file="profile-avatar.tsx">
        {firstLetter}
      </div>;
  };
  return <div className="p-4 md:p-2" data-sentry-component="ProfileAvatar" data-sentry-source-file="profile-avatar.tsx">
      <div className="relative mx-auto size-32 md:flex  md:items-center md:gap-2">
        <div>
          {renderAvatar()}
        </div>
        {/* FIXME: uncomment when Upload feature is live  */}
        {/* <button
          type="button"
          onClick={onUpload}
          disabled
          className="absolute bottom-0 right-0 flex size-8 items-center justify-center rounded-full bg-white shadow-md md:static md:w-full md:gap-2 md:rounded md:bg-x-accent-alpha md:p-2 md:px-4 md:text-sm"
         >
          <span className="hidden text-white md:block">Upload</span>
          <Upload className="size-4 text-x-accent-alpha md:size-4 md:text-white" />
         </button> */}
        {/* <button type="button" className="hidden rounded bg-white p-2 shadow md:block">
          <Trash2 className="size-4 text-x-negative-base" />
         </button> */}
      </div>
    </div>;
}
;
export default ProfileAvatar;